import { render, staticRenderFns } from "./editProcessing.vue?vue&type=template&id=064d96d1&"
import script from "./editProcessing.vue?vue&type=script&lang=js&"
export * from "./editProcessing.vue?vue&type=script&lang=js&"
import style0 from "./editProcessing.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports